import React, { Component } from "react";
import { withTranslation } from 'react-i18next';
import { Modal, Button } from 'react-bootstrap'
class PDPAModalComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showPDPA: true
        };
    }

    onClickConfirmPDPA = () => {
        localStorage.setItem('allowCookie', true);
        this.setState({ showPDPA: false })
    }

    openPDPA = () => {
        if (process.env.REACT_APP_PDPA_LINK) {
          const newWindow = window.open(process.env.REACT_APP_PDPA_LINK, '_blank', 'noopener,noreferrer')
          if (newWindow) newWindow.opener = null
        }
      }
    render() {

        const allowCookie = localStorage.getItem('allowCookie');

        return (
            <div>
                <Modal show={this.state.showPDPA && !allowCookie} animation={false}>
                    <Modal.Body>
                        <div className="">
                            <div className="row">
                                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12" style={{ textAlign: "center" }}>
                                    {`เว็บไซต์ของเรามีการใช้งานคุกกี้ (Cookies) กรุณากด "ยอมรับ" เพื่ออนุญาตให้เราสามารถทำการเก็บคุกกี้ในอุปกรณ์ของคุณ`}
                                    {process.env.REACT_APP_PDPA_LINK?<a href="#" onClick={this.openPDPA}  >นโยบายการใช้คุกกี้</a>:""}
                                </div>

                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>

                        <Button variant="primary" div className="col-xs-12 col-sm-12 col-md-12 col-lg-12" onClick={this.onClickConfirmPDPA} >
                            {"ยอมรับ"}
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>

        )
    }
}
export default withTranslation()(PDPAModalComponent);